export const organization: { [key: string]: string } = {
  cmt: "공동체",
  gar: "다락방",
  leaf: "순",
  month: "월 선택",
  plcCd: "장소 선택",
};

type PageTitleProps = {
  [key: string]: {
    mainTitle: string;
    subTitle: string;
    guide?: string[];
  };
};

export const pageTitle: PageTitleProps = {
  dashboard: {
    mainTitle: "Dashboard",
    subTitle: "대시보드",
  },
  mypage: {
    mainTitle: "MyPage",
    subTitle: "마이페이지",
  },
  schedule: {
    mainTitle: "Schedule",
    subTitle: "교회 일정",
  },
  home: {
    mainTitle: "Schedule",
    subTitle: "교회 일정",
    guide: [
      "기본 권한 안내 - 회원가입을 완료한 모든 사용자는 자동으로 USER(일반 유저) 권한이 부여됩니다.",
      "권한별 안내 - USER(일반유저):홈 화면 내 예약 현황 확인가능, LEADER(순장/리더): '예약하기' 메뉴 이용 가능",
      "권한 변경 방법 - 본인이 '순장' 또는 '리더'라면, 교역자에게 권한 변경 요청 문자를 전송하세요. (이름, 소속, 전화번호 기재)",
      "권한 확인 방법 - 본인의 현재 권한은 '마이페이지'에서 확인할 수 있습니다.",
      "문의 : 목회지원실 (031-651-9680)",
    ],
  },
  reservation: {
    mainTitle: "Reservation",
    subTitle: "예약하기",
    guide: [
      "예약 시간은 최대 2시간입니다. 2시간을 넘길 경우 목회지원실로 연락해주세요.",
      "순 / 다락방 / 부서 / 팀 별 모임 시에만 장소를 예약할 수 있습니다. (개인적 용무 불가)",
      "장소 사용의 우선순위는 예배입니다. 시간이 겹칠 경우 목회지원실에서 조정 후 다시 연락드립니다.",
      "예약 후 장소를 사용하지 않을 경우, 꼭 예약을 취소해야 합니다.",
      "장소 사용 후 깨끗하게 정리정돈 부탁드립니다.",
      "문의 : 목회지원실 (031-651-9680)",
    ],
  },
  admin: {
    mainTitle: "Admin",
    subTitle: "통합관리",
    guide: [
      "총 4개의 권한이 존재합니다. (USER : 일반 유저, LEADER : 순장, MINISTRY : 교역자, ADMIN : 관리자)",
      "교역자 혹은 관리자가 회원가입 승인 시 해당 유저는 USER 권한을 가지게 됩니다.",
      "교역자와 관리자는 [통합관리] - [회원정보 관리]에서 일반 USER에게 LEADER 권한을 부여할 수 있습니다.",
      "예약 후 장소를 사용하지 않을 경우, 꼭 예약을 취소해야 합니다.",
      "장소 사용 후 깨끗하게 정리정돈 부탁드립니다.",
      "문의 : 목회지원실 (031-651-9680)",
    ],
  },
  view: {
    mainTitle: "Reservation",
    subTitle: "월별 예약 내역",
  },
  chart: {
    mainTitle: "Statistics",
    subTitle: "예약 통계",
  },
  youth: {
    mainTitle: "Youth",
    subTitle: "대학청년부 양육노트",
  },
};

export const RESERVATION_STATE: { [key: string]: string } = {
  request: "승인 대기",
  approve: "승인 완료",
  reject: "승인 반려",
  cancel: "예약 취소",
  deleted: "삭제",
};
